var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((5),function(item,idx){return _c('span',{key:idx,staticClass:"star"},[(_vm.list[idx])?_c('i',{style:({
        width:_vm.list[idx] * 100+'%'
      })}):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }